<template>
    <section class="container margin-both-lg">
        <div class="inner">
            <div class="icon">
                <svg width="88px" height="208px" viewBox="0 0 88 208" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
                    <g transform="matrix(0.9902681 -0.1391731 0.1391731 0.9902681 0.3746481 9.148388)">
                    <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" transform="translate(14 168)" :fill="markColor" stroke="none" />
                    <path d="M29.7433 0C21.0558 0 12.8331 3.78516 7.17689 10.375C1.52064 16.9688 -0.959826 25.6719 0.337049 34.0469L13.9035 130.23C15.0167 138.129 21.7667 144 29.7433 144C37.7199 144 44.4699 138.129 45.5831 130.23L59.1183 34.2461C60.4464 25.6641 57.9581 16.9609 52.3019 10.375C46.6535 3.78516 38.4308 0 29.7433 0Z" transform="translate(0.2567007 0)" :fill="markColor" stroke="none" />
                    </g>
                </svg>
            </div>
            <div class="content">
                <h2 class="titler">{{data.title}}</h2>
                    <HtmlContent class="description" :html="data.description" />
                <div class="btn-block" v-if="data.link && data.link.url">
                    <Button hasIcon iconType="link" uppercase link type="light">
                        <AcfLink :data="data.link" />
                    </Button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Button from '@/components/elements/Button';
import AcfLink from '@/components/elements/AcfLink';
import HtmlContent from '@/components/elements/HtmlContent'

export default {
    name: 'did-you-know',
    props: ['data'],
    computed:{
        markColor(){
            return this.data.mark_color || '#FEAD00'
        }
    },
    components:{
        Button,
        AcfLink,
        HtmlContent
    },
};
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.module-did_you_know{
    .inner{
        padding: 50px;
        display: flex;
        background-color: #fff;
        border-radius: $blocksRadius;
    }
    .content{
        padding-left: 50px;
        padding-right: 50px;
    }
    .titler{
        margin-top: 0;
        margin-bottom: 15px;
        @include fluid-type($smallResText, $wideResText, 20px, 25px);
    }
    .description{
        @include fluid-type($smallResText, $wideResText, 20px, 25px);
        margin-bottom: 25px;
    }
    .fill-button{
        align-items: center;
        display: flex;
        @include fluid-type($smallResText, $wideResText, 14px, 18px);
        .icon{
            margin-right: 25px;
        }
    }
}
</style>
